module.exports = __webpack_public_path__ + "static/media/no-gift.983122cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/my-gift/no-gift.png
// module id = 517
// module chunks = 1